import { ArticleHeading1, UIHeading3, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { FullscreenPopup } from '../../components/Advantages/components/FullscreenPopup';
import { ABContent } from '../../components/Advantages/components/FullscreenPopup/components/ABContent';
import { ABHeader } from '../../components/Advantages/components/FullscreenPopup/components/ABHeader';
import { NewbuildingCurrentDecoration } from '../../components/NewbuildingCurrentDecoration';
import { selectIsOfferPageRedesign } from '../../selectors';
import { getDecorationInfo, getNewbuildingName } from '../../selectors/newObject';
import { ABCallButtonContainer, FavoriteButtonContainer, MoreFlatsButton } from './parts';
import { trackClickNewbuildingCurrentDecoration } from './tracking';

export const NewbuildingCurrentDecorationContainer = () => {
  const decorationInfo = useSelector(getDecorationInfo);
  const name = useSelector(getNewbuildingName);
  const isRedesigned = useSelector(selectIsOfferPageRedesign);

  const [isOpened, setOpenedState] = React.useState(false);

  const onClick = React.useCallback(
    type => {
      setOpenedState(true);
      trackClickNewbuildingCurrentDecoration(type);
    },
    [setOpenedState],
  );

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  if (!decorationInfo) {
    return null;
  }

  return (
    <NewbuildingCurrentDecoration
      title={
        isRedesigned ? (
          <ArticleHeading1 as="h2">{decorationInfo.title}</ArticleHeading1>
        ) : (
          <UIHeading3>{decorationInfo.title}</UIHeading3>
        )
      }
      subtitle={decorationInfo.block.subtitle}
      thumbnails={decorationInfo.block.thumbnails}
      onClick={() => onClick(decorationInfo.type)}
      popup={
        <FullscreenPopup
          isOpened={isOpened}
          header={
            <ABHeader
              title={<UIText1>ЖК «{name}»</UIText1>}
              callButton={<ABCallButtonContainer />}
              favoriteButton={<FavoriteButtonContainer />}
              onClose={onClose}
            />
          }
          onClose={onClose}
          content={
            <ABContent
              title={decorationInfo.title}
              description={decorationInfo.dialog.description}
              images={decorationInfo.dialog.fullImages}
              moreFlatsButton={
                decorationInfo.dialog.searchUrl ? <MoreFlatsButton href={decorationInfo.dialog.searchUrl} /> : null
              }
            />
          }
        />
      }
    />
  );
};
